<form
  [class.active]="isOpen"
  [class.error]="!!errorText"
  class="search">
  <div
    (click)="openList()"
    class="input-block">
    <input
      [value]="currentValue?.payment_type_name"
      readonly
      id="name"
      class="input"
      type="text"
      placeholder=" "/>
    <label
      for="name"
      class="placeholder">
      {{ title }}
    </label>
    <ng-container>
      <span
        class="input-block__error">
        {{ errorText | translate }}
      </span>
    </ng-container>
  </div>

  <div class="search__block">
    <div class="search__block-input-text">
      <img
        src="assets/img/input-search.svg"
        alt="Search"
        class="search__icon">
      <input
        #searchInput
        [formControl]="searchFormControl"
        (focus)="focusFn()"
        (blur)="onTouchedFn($event)"
        placeholder="{{'FORM_SEARCH' | translate}}"
        class="search__input">
    </div>
    <ul class="search__block-list">
      <li
        *ngFor="let item of itemList"
        (click)="selectItem(item)"
        class="item">{{ item.description }}
      </li>
    </ul>
  </div>
</form>
